import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Property, SelectInput } from '@/components/form/fields/select/SelectInput';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { CAPITAL_PURCHASE_OPTION } from '@/pages/customer/financeModels/const';
import {
  DefaultFinanceModelData,
  DefaultFinanceModelOption,
  useDefaultFinanceModels,
  useSaveDefaultFinanceModels
} from '@/services/financemodel/useDefaultFinanceModels';
import { FC, useState } from 'react';

const DefaultModelSelector: FC<{
  defaultData: DefaultFinanceModelData;
  setDefault: (newDefault?: DefaultFinanceModelOption) => void;
}> = ({ defaultData, setDefault }) => {
  const options: Property[] = defaultData.options.map(o => {
    return {
      id: o.name,
      name: o.name
    };
  });

  options.unshift(CAPITAL_PURCHASE_OPTION);

  return (
    <div>
      <div>{defaultData.categoryName}</div>
      <SelectInput
        id={defaultData.categoryId || ''}
        placeholder="Please Select"
        value={options.find(o => o.id === defaultData.selectedDefault?.name) || CAPITAL_PURCHASE_OPTION}
        onChange={value => {
          if (value) {
            const selectedOption = defaultData.options.find(o => o.name === value.id);

            setDefault(selectedOption);
          }
        }}
        options={options}
      ></SelectInput>
    </div>
  );
};
export const DefaultModelsModal: FC<ModalProps> = props => {
  const { defaults, setDefaultModel } = useDefaultFinanceModels();
  const save = useSaveDefaultFinanceModels();

  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setErrorMessage('');
    setLoading(true);
    try {
      await save(defaults);
      props.close();
    } catch (error) {
      setErrorMessage('Unable to save defaults');
    }
    setLoading(false);
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Default Finance Models</h1>
        </Modal.Controls>
        <div className="space-y-5 my-4">
          {defaults.map(data => (
            <DefaultModelSelector
              defaultData={data}
              key={data.categoryId}
              setDefault={newDefault => setDefaultModel(data.categoryId, newDefault)}
            />
          ))}
        </div>
        {errorMessage && <div className="text-red-500">{errorMessage}</div>}
        <div className="mt-2 flex gap-2 justify-between">
          <Button onClick={props.close}>Cancel</Button>
          <Button type="button" variant={ButtonVariant.Primary} onClick={onSubmit} loading={loading}>
            Confirm
          </Button>
        </div>
      </Card>
    </Modal>
  );
};
